import styled from 'styled-components';

export const LightedBorder = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 50px;
  border-radius: 50%;
  container-type: inline-size;
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: var(--lighted-border-color);
    clip-path: ellipse(50% 100% at 50% 100%);
    mix-blend-mode: plus-lighter;
    width: 50%;
    margin: 0 auto;
    @container (min-width: 100px) {
      width: 100%;
    }
  }
  &:after {
    content: '';
    position: absolute;
    top: 22px;
    left: 0;
    right: 0;
    margin: 0 auto;
    height: 72px;
    border-radius: 50%;
    background: var(--lighted-border-color);
    width: 30%;
    filter: blur(20px);
    @container (min-width: 100px) {
      top: 36px;
      filter: blur(30px);
      width: 100%;
    }
  }
`;
